import { Component, OnInit } from '@angular/core';

import { GlobalService } from 'src/app/_services/global.service';

import { ActivatedRoute, Router } from '@angular/router';
import { GridService } from 'src/app/_services/grid.service';

import { ApiService } from 'src/app/_services/api.service';
import { CheckboxRenderer } from  'src/app/components/grid-addons/checkbox-renderer/checkbox-renderer.component';
import { Location } from '@angular/common'

import {
  ColDef
} from 'ag-grid-community';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';
import 'ag-grid-enterprise';
import {   MessageService } from 'primeng/api';


@Component({
  selector: 'app-surveys-emailsnotsent',
  templateUrl: './surveys-emailsnotsent.component.html',
  styleUrls: ['./surveys-emailsnotsent.component.css'],
  providers: [ MessageService]

})
export class SurveysEmailsnotsentComponent implements OnInit {
  emaillist:any=[];
  columns: ColDef[] = [
 
    { field: 'name',headerName: 'Name'},
    { field: 'surname',headerName: 'Surname'},
    { field: 'email',headerName: 'Email',width:400 },
    { field: 'residence',headerName: 'Residence' },
  
  ];


  frameworkComponents = {
    checkboxRenderer: CheckboxRenderer
  }

  gridApi;
  gridColumnApi;
  defaultColDef = {
    width: 250,
    minWidth: 100,
    sortable:true,
    flex:1
  };

 
  
  defaultSortModel = [
    { colId: 'name', sort: 'asc', sortIndex: 0 },
  ];

 
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    public globalService: GlobalService,
    public gridService: GridService,
    private apiService: ApiService,
    private location: Location
   ) { }

  ngOnInit(): void {
    const params: any = {target_id : this.route.snapshot.paramMap.get('id')};
    this.apiService.get('surveys/emailsnotsent',params).subscribe(data => {
      this.emaillist=data.Result;
   
      });
    

  }
  public back() {
    this.location.back();
  }

}
